import React from "react";

// Gerekli Component'leri import ediyoruz
import PageBanner from "../components/PageBanner/PageBanner";
import TwoColumnSection from "../components/TwoColumnSection/TwoColumnSection";
import TeamSection from "../components/TeamSection/TeamSection";
import ImageTextSection from "../components/ImageTextSection/ImageTextSection";
import SectionTitle from "../components/SectionTitle/SectionTitle";

// Görselleri import ediyoruz
import bannerBg from "../assets/images/slider0.jpg";
import aboutImage from "../assets/images/about-image.png"; // Yeni bölüm için görsel

// Yeni bölümün metin içeriği
const aboutTextContent = [
  "Vet-İzmir Veteriner Kliniği olarak, patili dostlarımızın sağlığına bütüncül bir bakış açısıyla yaklaşıyoruz. Her hastamızı yalnızca bir vaka değil, bir can olarak değerlendiriyor; onların yaşam kalitesini artırmak için bilimsel, etik ve şefkatli bir hizmet sunuyoruz.",
  "Klinik kurucumuz Veteriner Hekim Ayşegül Göçer, yıllara dayanan mesleki deneyimi ve sürekli gelişimi hedefleyen yaklaşımıyla ve alanında uzman hekimler ile çalışıp hem tanı hem de tedavi süreçlerinde en güncel uygulamaları kliniğimize taşımaktadır.",
  "Vet-İzmir’de, sadece tedavi edici değil aynı zamanda ÖNLEYİCİ hekimliği de esas alıyoruz. Aile üyemiz olarak gördüğümüz dostlarımızın sağlığını korumak için düzenli kontrolleri, aşı programlarını, beslenme danışmanlığını ve davranışsal değerlendirmeleri titizlikle takip edip yürütüyoruz.",
];

const About = () => {
  return (
    <div className="about-page">
      {/* 1. Bölüm: Page Banner (Hazır) */}
      <PageBanner title="Hakkımızda" bgImage={bannerBg} />

      {/* 2. Bölüm: TwoColumnSection (Hazır) */}
      <TwoColumnSection />

      <SectionTitle
        smallTitle="Vet-İzmir"
        mainTitle="Patili Dostlarınızın Yanında, 9 Yıllık Tecrübeyle"
      />
      {/* Yeni bölümü buraya ekleyelim */}
      <ImageTextSection
        image={aboutImage}
        textContent={aboutTextContent}
        imageOnLeft={true} // Görselin sağda olmasını istiyorsak
      />

      {/* 3. Bölüm: TeamSection (Hazır) */}
      <SectionTitle smallTitle="Ekibimiz" mainTitle="Alanında Uzman Kadromuz" />
      <TeamSection />
    </div>
  );
};

export default About;
